// Lazy raw-imports of the academy markdown single-source. Vite resolves the
// glob at build; each module is fetched on demand (code-split).
import { parseAcademyMarkdown, type ParsedAcademyModule } from './academy-content';

const RAW_MODULES = import.meta.glob('../content/academy/**/*.md', {
  query: '?raw',
  import: 'default',
}) as Record<string, () => Promise<string>>;

function keyFor(type: 'trading' | 'crypto', slug: string): string {
  return `../content/academy/${type}/${slug}.md`;
}

export async function loadAcademyModule(
  type: 'trading' | 'crypto',
  slug: string,
): Promise<ParsedAcademyModule> {
  const loader = RAW_MODULES[keyFor(type, slug)];
  if (!loader) throw new Error(`academy module not found: ${type}/${slug}`);
  return parseAcademyMarkdown(await loader());
}

export async function loadAcademyRaw(
  type: 'trading' | 'crypto',
  slug: string,
): Promise<string> {
  const loader = RAW_MODULES[keyFor(type, slug)];
  if (!loader) throw new Error(`academy module not found: ${type}/${slug}`);
  return loader();
}
